import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsUsOnPage from "../ListVpsUsOnPage";

const PageListVpsUsOn = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps-us/chuyen-khach-hang.html?' + listVps);
    }

    return <ListVpsUsOnPage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default PageListVpsUsOn;